/**
 * @engine/vfx — Built-in VFX preset graphs (one file per preset).
 *
 * Each preset is a pure factory returning a hand-authored VFXGraphData.
 * Re-exported by graph/VFXGraphAsset.ts as the public preset surface.
 */

export { createFireworkVFXGraph } from './firework';
export { createCosmicAuroraVFX } from './cosmicAurora';
export { createElectricStormVFX } from './electricStorm';
export { createMagicPortalVFX } from './magicPortal';
export { createPhoenixRisingVFX } from './phoenixRising';
export { createWaterRippleGridVFX } from './waterRippleGrid';
export { createSingularityVFX } from './singularity';
export { createBlackHoleVFX } from './blackHole';
export { createTornadoVFX } from './tornado';
export { createForceFieldVFX } from './forceField';
export { createSmokeVFX } from './smoke';
export { createExplosion2DVFX } from './explosion2d';
